import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Tooltip, OverlayTrigger } from 'ui';
import UnreadWrapper from 'components/UnreadWrapper';
import './Meta.scss';
import CONSTS from '../../../../../constants';

class Meta extends Component {
  getTooltip(icon, props) {
    const typeMap = {
      upload: 'Upload Attachment',
      download: 'Download Conversation',
      mailmerge: 'Mailmerge Tag Builder',
      notes: this.props.noteMode.on
        ? 'Change to Conversation Mode'
        : 'Change to Notes Mode',
      forward: 'Forward Conversation',
      cc: 'CC and BCC',
      signature: this.props.exclude_signature.excludeSignature
        ? 'Include Email Signature'
        : 'Exclude Email Signature',
      ai_suggestion: 'Generate AI Reply',
    };
    return (
      <Tooltip id={`${icon}-icon`} {...props}>
        {typeMap[icon]}
      </Tooltip>
    );
  }

  getNoteButton() {
    return !this.props.notes.show ? null : (
      <span
        className="upload-attachment"
        onClick={this.props.notes.onClick.bind(this)}
        id="notes-icon"
      >
        <OverlayTrigger placement="top" overlay={this.getTooltip('notes')}>
          <i
            className={`far ${
              this.props.noteMode.on ? 'fa-comments' : 'fa-sticky-note'
            }`}
          />
        </OverlayTrigger>
      </span>
    );
  }

  getAttachments() {
    return !this.props.attachments.show ? null : (
      <span
        style={{ marginLeft: '10px' }}
        className="upload-attachment"
        onClick={this.props.attachments.onClick}
        id="upload-icon"
      >
        <input
          ref={this.props.attachments.setAttachmentFileRef}
          onChange={this.props.attachments.onChange.bind(this)}
          style={{ display: 'none' }}
          type="file"
          accept={CONSTS.ATTACHMENT_ACCEPT_MIME_TYPES}
          multiple
        />
        <OverlayTrigger placement="top" overlay={this.getTooltip('upload')}>
          <i className="far fa-paperclip"></i>
        </OverlayTrigger>
      </span>
    );
  }

  getDownloadLink() {
    return !this.props.downloads.show ? null : (
      <span
        style={{ marginLeft: '10px' }}
        className="export-conversation"
        onClick={this.props.downloads.onClick.bind(this)}
        id="download-icon"
      >
        <OverlayTrigger placement="top" overlay={this.getTooltip('download')}>
          <i className="far fa-download"></i>
        </OverlayTrigger>
      </span>
    );
  }

  getSavedReplies() {
    return !this.props.saved_replies.show
      ? null
      : this.props.saved_replies.render();
  }

  getEmoji() {
    return !this.props.emoji.show ? null : this.props.emoji.render();
  }

  getMailMergeTagBuilder() {
    return !this.props.mail_merge.show ? null : (
      <span
        style={{ marginLeft: '10px' }}
        className="export-conversation"
        onClick={this.props.mail_merge.onClick}
        id="mailmerge-icon"
      >
        <OverlayTrigger placement="top" overlay={this.getTooltip('mailmerge')}>
          <i className="far fa-id-card"></i>
        </OverlayTrigger>
      </span>
    );
  }

  getForward() {
    if (!this.props.mail_forward.show) {
      return null;
    }
    return (
      <span
        style={{ marginLeft: '10px' }}
        className="export-conversation"
        onClick={this.props.mail_forward.onClick}
        id="forward-icon"
      >
        <OverlayTrigger placement="top" overlay={this.getTooltip('forward')}>
          <i className="far fa-reply fa-flip-horizontal"></i>
        </OverlayTrigger>
      </span>
    );
  }

  getCC() {
    if (!this.props.mail_cc.show) {
      return null;
    }
    return (
      <UnreadWrapper hasUnread={this.props.mail_cc.hasCCs}>
        <span
          style={{ marginLeft: '10px' }}
          className="export-conversation"
          onClick={this.props.mail_cc.onClick}
          id="cc-icon"
        >
          <OverlayTrigger placement="top" overlay={this.getTooltip('cc')}>
            <i className="far fa-reply-all"></i>
          </OverlayTrigger>
        </span>
      </UnreadWrapper>
    );
  }

  getExcludeSignature() {
    if (!this.props.exclude_signature.show) {
      return null;
    }
    return (
      <span
        style={{ marginLeft: '10px' }}
        className="export-conversation"
        onClick={this.props.exclude_signature.onClick}
        id="signature-icon"
      >
        <OverlayTrigger placement="top" overlay={this.getTooltip('signature')}>
          <i
            className={`far fa-pencil ${
              this.props.exclude_signature.excludeSignature
                ? 'Meta-icon-disabled'
                : ''
            }`}
          ></i>
        </OverlayTrigger>
      </span>
    );
  }

  getProgress() {
    const style = {
      display: this.props.progress.isUploading ? 'inline-block' : 'none',
      width: 320,
      margin: 5,
    };
    return (
      <div className="row">
        <progress value={this.props.progress.value} max={100} style={style} />
      </div>
    );
  }

  getSendButton() {
    return !this.props.send.show ? null : (
      <button
        type="submit"
        disabled={this.props.send.disabled}
        className="gecko-btn btn btn-primary btn-sm pull-right"
        onClick={this.props.send.onClick}
      >
        <i className={this.props.send.icon}></i> {this.props.send.label}
      </button>
    );
  }

  getAiSuggestion() {
    return !this.props.ai_suggestion.show
      ? null
      : this.props.ai_suggestion.render();
  }

  render() {
    return (
      <div className="reply-box-meta">
        <div className="row">
          <div className="col">
            {this.getNoteButton()}
            {this.getAttachments()}
            {this.getDownloadLink()}
            {this.getSavedReplies()}
            {this.getEmoji()}
            {this.getMailMergeTagBuilder()}
            {this.getCC()}
            {this.getForward()}
            {this.getExcludeSignature()}
            {this.getSendButton()}
            {this.getAiSuggestion()}
          </div>
        </div>
        {this.getProgress()}
      </div>
    );
  }
}

Meta.propTypes = {
  attachments: PropTypes.object,
  downloads: PropTypes.object,
  mail_merge: PropTypes.object,
  noteMode: PropTypes.object,
  notes: PropTypes.object,
  progress: PropTypes.object,
  saved_replies: PropTypes.object,
  emoji: PropTypes.object,
  send: PropTypes.object,
  mail_forward: PropTypes.object,
  mail_cc: PropTypes.object,
  ai_suggestion: PropTypes.object,
};

export default Meta;
